import { render, staticRenderFns } from "./BannerTable.vue?vue&type=template&id=11261df8&scoped=true"
import script from "./BannerTable.vue?vue&type=script&lang=js"
export * from "./BannerTable.vue?vue&type=script&lang=js"
import style0 from "./BannerTable.vue?vue&type=style&index=0&id=11261df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11261df8",
  null
  
)

export default component.exports